// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddLotMutation($input: AddLotInput!) {
    addLot(input: $input) {
      lotEdge {
        node {
          id
          lotNumber
          binNumber
          expiresAt
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PaginatedLotsContainer_lots',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'lotEdge',
        },
      ],
    });
  },
};
